// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import Loading from '../../../_common/Loading';
import Page from '../../pageLayout/Page';
import { QuestRoute } from '../../../_common/api/QuestRoutes';
import ItemList from '../../ItemList';
import { useGlobalState } from '../../../_common/globalState/GlobalStateProvider';
import { HamQuest } from '../../../../App';

const Clubs = () => {
    const {
        state: {
            active_user,
        },
    } = useGlobalState();

    const [clubs, setClubs] = useState(null);

    useEffect(() => {
        HamQuest.get(QuestRoute.products.washClubs)
            .then((res) => setClubs(res))
    }, [active_user.isLoggedIn])

    if (!clubs) return <Loading />

    return (
        <Page>
            <ItemList items={clubs} />
        </Page>
    );
}

export default Clubs;